<template>
    <BaseMap class="h-full" v-if="showMap" @map-loaded="mapLoaded" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { useAutosomalStore } from "@/store/ancestry/autosomal";
import { calculateOpacity, MapLayer, useMap } from "@/view/ancestry/recent/mapHelpers";
import BaseMap from "@/components/Maps/BaseMap.vue";

const autosomalStore = useAutosomalStore();

const props = defineProps(['modelValue']);

const emits = defineEmits(['update:modelValue'])

const showMap = ref(false);

setTimeout(() => {
    showMap.value = true;
}, 500);

// Tileset for the active result's panel (Irish panel upgrade falls back to default).
// Used as both the vector source url and the source-layer name for every layer.
const tileset = autosomalStore.tileset;

const mapSource = {
    id: tileset,
    type: "vector",
    url: `mapbox://${tileset}`,
};

async function mapLoaded(map) {
    const { boundingBoxMove, createActiveLayer, getFeatures } = useMap(map);

    map.addSource("tests", {
        type: "vector",
        url: mapSource.url,
    });
    
    autosomalStore.mapItems?.forEach((mapElement) => {
        const layer = new MapLayer(
            mapElement.id,
            mapElement.properties.colour,
            mapElement.properties.code,
            false,
            calculateOpacity(
                typeof mapElement.properties.percentage !== "number"
                    ? 100
                    : mapElement.properties.percentage
            ),
            tileset
        );
        map.addLayer(layer);

        map.on("click", mapElement.id, ({ features }) => {
            const [feature] = features;
            emits('request-history-result', feature.layer.id);
            emits('update:modelValue', feature.layer.id);
        });
    });

    setTimeout(() => {
        const allFeatures = getFeatures();
        watch(
            () => props.modelValue,
            (groupId) => {
                boundingBoxMove(allFeatures, 100);
                setTimeout(() => {
                    if (groupId) {
                        createActiveLayer(groupId);
                    }
                }, 1200)
            },
            { immediate: true }
        );
    }, 500);
}

</script>
